import * as React from 'react';
import { SVGProps } from 'react';

const IconRulerStrokedSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 3h12v6H0V3Zm3 1h2v3h1V4h2v2h1V4h2v4H1V4h1v2h1V4Z"
    />
  </svg>
);
export default IconRulerStrokedSizeXs;
